const e = {
  AU: {
    countryCode: "AU",
    locale: "en-AU",
    name: "AU"
  },
  BR: {
    countryCode: "BR",
    locale: "pt-BR",
    name: "BR"
  },
  CO: {
    countryCode: "CO",
    locale: "es-CO",
    name: "CO"
  },
  DE: {
    countryCode: "DE",
    locale: "de-DE",
    name: "DE"
  },
  DK: {
    countryCode: "DK",
    locale: "da-DK",
    name: "DK"
  },
  ES: {
    countryCode: "ES",
    locale: "es-ES",
    name: "ES"
  },
  IT: {
    countryCode: "IT",
    locale: "it-IT",
    name: "IT"
  },
  OC: {
    countryCode: "UK",
    locale: "en-GB",
    name: "OC"
  },
  US: {
    countryCode: "US",
    locale: "en-US",
    name: "US"
  },
  XX: {
    countryCode: "XX",
    locale: "xx-XX",
    name: "XX"
  }
};
export {
  e as REPUBS
};
